import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e453e9ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 pt-0 pb-3" }
const _hoisted_2 = { class: "px-5 pt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Size:", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex item-center justify-start"
}
const _hoisted_5 = { class: "flex items-center justify-between border-solid border-current border-2 rounded text-xs pl-1.5 pr-1.5 py-0.5" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = ["onClick", "title"]
const _hoisted_8 = { class: "px-5" }
const _hoisted_9 = { class: "px-5 pt-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Color:")
const _hoisted_12 = {
  key: 0,
  class: "flex item-center justify-start"
}
const _hoisted_13 = { class: "flex items-center justify-between border-solid border-current border-2 rounded text-xs pl-1.5 pr-1.5 py-0.5" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = ["onClick", "title"]
const _hoisted_16 = {
  class: "pt-3 mt-3",
  style: {"word-wrap":"break-word"}
}
const _hoisted_17 = { class: "my-2 flex items-center justify-between" }
const _hoisted_18 = { class: "flex items-center justify-start" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_BulkUpdate = _resolveComponent("BulkUpdate")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_edit = _resolveComponent("edit")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ColorForm = _resolveComponent("ColorForm")!
  const _component_SizeForm = _resolveComponent("SizeForm")!
  const _component_EditVariantForm = _resolveComponent("EditVariantForm")!
  const _component_AddSetCost = _resolveComponent("AddSetCost")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.costBy,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.costBy) = $event)),
                  placeholder: "Cost by color/Cost by size",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value,
                        size: 25
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_row, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 2,
              class: "grid-content font-bold pr-4"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 21,
              style: {"margin":"auto","overflow":"auto"}
            }, {
              default: _withCtx(() => [
                (_ctx.sizesValue && _ctx.sizesValue.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesValue, (size, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "pr-1",
                          key: `size-catalog-${index}`
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(size.name), 1),
                            _createElementVNode("div", {
                              class: "flex items-center justify-between text-xs ml-1 rounded-full catalog-attribute",
                              onClick: ($event: any) => (_ctx.deleteAttribute(`size`, size.code)),
                              title: `Delete size ${size.name}`
                            }, [
                              _createVNode(_component_el_icon, {
                                class: "bg-neutral-500 round cursor-pointer",
                                size: 12
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CloseBold)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_7)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 1 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "font-bold cursor-pointer text-right text-xs",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAttributeDialog(`size`))),
                  title: "Add size"
                }, " Add + ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_divider)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_row, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                class: "grid-content font-bold pr-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 21,
                style: {"margin":"auto","overflow":"auto"}
              }, {
                default: _withCtx(() => [
                  (_ctx.colorsValue && _ctx.colorsValue.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorsValue, (color, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "pr-1",
                            key: `color-catalog-${index}`
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(color.name), 1),
                              _createElementVNode("div", {
                                class: "flex items-center justify-between ml-1 text-xs rounded-full catalog-attribute",
                                onClick: ($event: any) => (_ctx.deleteAttribute(`color`, color.name)),
                                title: `Delete color ${color.name}`
                              }, [
                                _createVNode(_component_el_icon, {
                                  class: "bg-neutral-500 round cursor-pointer",
                                  size: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CloseBold)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_15)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "font-bold cursor-pointer text-right text-xs",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAttributeDialog(`color`))),
                    title: "Add color"
                  }, " Add + ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createVNode(_component_BulkUpdate, {
              selected: _ctx.selectedIds,
              onSelectedAction: _ctx.onSelectedAction
            }, null, 8, ["selected", "onSelectedAction"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.filterColors,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterColors) = $event)),
              placeholder: "Filter Colors",
              multiple: "",
              filterable: "",
              "allow-create": "",
              clearable: "",
              onChange: _ctx.onSelectFilter,
              class: "mx-1",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorsValue, (color, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: `color-catalog-${index}`,
                    value: color.name
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.filterSizes,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterSizes) = $event)),
              placeholder: "Filter Sizes",
              multiple: "",
              filterable: "",
              "allow-create": "",
              clearable: "",
              onChange: _ctx.onSelectFilter,
              class: "mx-1",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesValue, (size, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: `size-catalog-${index}`,
                    value: size.name
                  }, null, 8, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.variants,
          stripe: "",
          fit: "",
          style: {"width":"100%"},
          onSelectionChange: _ctx.handleSelectionChange,
          "header-cell-class-name": "custom-text-mini",
          "cell-class-name": "font-light custom-text-mini"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              "min-width": "4"
            }),
            _createVNode(_component_el_table_column, {
              prop: "catalogVariantCode",
              label: "Variant code",
              "min-width": "12"
            }),
            _createVNode(_component_el_table_column, {
              prop: "color",
              label: "Color",
              "min-width": "10"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_18, [
                  (scope.row.color.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "w-4 h-4 bg-color-variant mr-1",
                        style: _normalizeStyle(`--color:${scope.row.color.value}`)
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "w-4 h-4 bg-color-variant mr-1",
                        style: _normalizeStyle(`--color:${scope.row.color.name}`)
                      }, null, 4)),
                  _createElementVNode("div", null, _toDisplayString(scope.row.color.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "size",
              label: "Size",
              "min-width": "10"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.size.name), 1)
              ]),
              _: 1
            }),
            (_ctx.isDropShip === false)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "DS Qty",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.designs?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(scope.row.designs?.length), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.designs?.length), 1)
                        ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isDropShip === false)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: "Design",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.designs?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.designs, (item) => {
                            return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designs, (item) => {
                            return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item.name), 1))
                          }), 128))
                        ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              prop: "inStock",
              label: "Stock",
              sortable: "",
              "min-width": "8"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "custom-text-mini custom-capitalize",
                  style: _normalizeStyle(`color: ${scope.row.inStock ? '' : 'red'}`)
                }, _toDisplayString(scope.row.inStock ? 'In Stock' : 'Out of Stock'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "designCost",
              label: "Design Cost",
              "min-width": "8"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.designCost)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "cost",
              label: "Agency Cost",
              "min-width": "8",
              sortable: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.cost)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "cost1",
              label: "Seller Cost",
              "min-width": "8"
            }),
            _createVNode(_component_el_table_column, { label: "Ship US" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "shipUsFirst",
                  label: "First",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipUsFirst)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shipUsAdditional",
                  label: "Add",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipUsAdditional)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Ship ROW" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "shipRowFirst",
                  label: "First",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipRowFirst)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "shipRowAdditional",
                  label: "Add",
                  "min-width": "8"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.shipRowAdditional)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "120px",
              label: "Actions",
              "min-width": "5"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (_ctx.openEditVariantDialog(scope.row._id)),
                  disabled: !scope.row._id,
                  title: 
                scope.row._id
                  ? 'Edit variant'
                  : 'Need save catalog to edit this variant'
              
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "mini" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_edit)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "title"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  onClick: ($event: any) => (
                scope.row._id
                  ? _ctx.deleteVariant(scope.row._id)
                  : _ctx.sliceVariant(scope.$index)
              ),
                  title: "Delete variant"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "mini" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_delete)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"])
      ]),
      _createVNode(_component_ColorForm, {
        ref: "colorDialog",
        onCallbackAttribute: _ctx.addAttribute,
        costBy: _ctx.costBy
      }, null, 8, ["onCallbackAttribute", "costBy"]),
      _createVNode(_component_SizeForm, {
        ref: "sizeDialog",
        onCallbackAttribute: _ctx.addAttribute,
        costBy: _ctx.costBy
      }, null, 8, ["onCallbackAttribute", "costBy"]),
      _createVNode(_component_EditVariantForm, { ref: "editVariantDialog" }, null, 512)
    ]),
    _createVNode(_component_AddSetCost, {
      ref: "addSetCostDialog",
      selected: _ctx.selectedIds
    }, null, 8, ["selected"])
  ], 64))
}